export default "/fonts/vendor/mdui/dist/roboto/Roboto-Regular.woff2?c065bd9fa03a7a797d95ba7f198a9dcf";